export default __webpack_public_path__ + "static/media/atomic-design-1.16b1a467.webp";